import React from 'react';
import { createIcon } from '../../../utils';

const IconSelfieWithIdCard = createIcon({
  viewBox: '0 0 114 88',
  path: (
    <>
      <path
        d="M3.08761 85.3315C3.13767 80.7132 2.63704 76.0386 3.58824 71.4766C5.69087 61.1698 13.5507 54.0733 23.2629 53.9607C33.8262 53.7917 44.3393 53.7917 54.9026 53.9607C66.6173 54.1297 74.9778 63.9295 74.9778 77.1087C74.9778 79.7557 75.0278 82.4592 74.9778 85.1062"
        stroke="#0D47A1"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path
        d="M38.6424 2.50021L38.6425 2.50021C49.6494 2.55024 58.5634 11.5606 58.5134 22.5736C58.4633 33.5785 49.4562 42.4913 38.4459 42.4445C27.4299 42.3414 18.5318 33.2721 18.6816 22.3376L18.6816 22.3376L18.6817 22.3262C18.7819 11.3521 27.7566 2.45027 38.6424 2.50021Z"
        fill="#CFDAEC"
        stroke="#0D47A1"
        strokeWidth="5"
      />
      <rect
        x="79"
        y="36"
        width="32"
        height="24"
        rx="3.55556"
        fill="#CFDAEC"
        stroke="#0D47A1"
        strokeWidth="4.44444"
      />
      <line
        x1="87"
        y1="44"
        x2="103"
        y2="44"
        stroke="#0D47A1"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="87"
        y1="52"
        x2="103"
        y2="52"
        stroke="#0D47A1"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </>
  ),
});

export default IconSelfieWithIdCard;
